var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2929 3.29289C17.6834 2.90237 18.3166 2.90237 18.7071 3.29289L20.7071 5.29289C21.0976 5.68342 21.0976 6.31658 20.7071 6.70711C20.3166 7.09763 19.6834 7.09763 19.2929 6.70711L19 6.41421V9C19 13.4183 15.4183 17 11 17H8C7.44772 17 7 16.5523 7 16C7 15.4477 7.44772 15 8 15H11C14.3137 15 17 12.3137 17 9V6.41421L16.7071 6.70711C16.3166 7.09763 15.6834 7.09763 15.2929 6.70711C14.9024 6.31658 14.9024 5.68342 15.2929 5.29289L17.2929 3.29289ZM5 4C5 3.44772 4.55228 3 4 3C3.44772 3 3 3.44772 3 4V17C3 19.2091 4.79086 21 7 21H20C20.5523 21 21 20.5523 21 20C21 19.4477 20.5523 19 20 19H7C5.89543 19 5 18.1046 5 17V4Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.9434e90b93078d602cac14727a5e3195.svg";
export { ForwardRef as ReactComponent };